<template>
  <div class="container">
    <div class="content poi-content">
      <form class="search-bar" @submit.prevent="handleSearch">
        <ion-input
          id="searchFor"
          v-model="searchFor"
          name="searchFor"
          enterkeyhint="go"
          placeholder="Merre jártatok?"
          class="form-control"
          autocapitalize="sentences"
          @input="handleSearch"
        />
        <ion-img :src="require('@/assets/images/icons/walk/unknown-marker.svg')" alt="search" class="search-button" />
      </form>

      <div class="poi__list">
        <div
          class="poi__list__item"
          v-for="poi in pois"
          :key="poi.id"
          @click="selectedPoi = selectedPoi === poi ? null : poi"
        >
          <ion-img :src="getCustomMarkerIcon(poi)" alt="poi" class="poi__list__item__marker" />
          <h1 class="poi__list__item__name">{{ poi.name }}</h1>
          <ion-img
            :src="require('@/assets/images/post/check.svg')"
            alt="checkmark"
            class="poi__list__item__check"
            v-show="selectedPoi === poi"
          />
        </div>
      </div>

      <ion-button
        type="submit"
        id="submit"
        expand="full"
        shape="round"
        strong="true"
        class="btn submit"
        @click.prevent="$emit('onSubmit', selectedPoi)"
        :style="!selectedPoi ? '--background: #333333' : ''"
      >
        {{ selectedPoi ? 'Helyszín megjelölése' : 'Vissza' }}
        <ion-ripple-effect></ion-ripple-effect>
      </ion-button>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted, ref } from 'vue'
import { IonInput, IonImg, IonRippleEffect } from '@ionic/vue'

import usePois from '@/composables/pois'

export default defineComponent({
  name: 'PoiSelector',
  components: {
    IonInput,
    IonImg,
    IonRippleEffect,
  },
  setup() {
    const { getPois } = usePois()

    const pois = ref([])
    const searchFor = ref('')
    const selectedPoi = ref(null)

    let timeout

    const search = async () => {
      pois.value = []
      selectedPoi.value = null

      try {
        pois.value = await getPois(searchFor.value || '*')
      } catch (err) {
        console.warn(err.message)
      }
    }

    const handleSearch = async () => {
      try {
        clearTimeout(timeout)
        timeout = setTimeout(search, 1000)
      } catch (error) {
        console.warn(error.message)
      }
    }

    onMounted(() => search())

    const getCustomMarkerIcon = marker => {
      if (marker.type === 'walkplace') {
        return require('@/assets/images/icons/walk/walkplace-marker.svg')
      } else if (marker.type === 'dogbeach') {
        return require('@/assets/images/icons/walk/dogbeach-marker.svg')
      } else if (marker.type === 'dogfriendly') {
        return require('@/assets/images/icons/walk/dogfriendly-marker.svg')
      } else if (marker.logo) {
        return marker.logo
      } else if (marker.type !== undefined) {
        return require(`@/assets/images/icons/walk/poi/${marker.type}.svg`)
      }

      return require('@/assets/images/icons/walk/unknown-marker.svg')
    }

    return {
      pois,
      searchFor,
      selectedPoi,
      handleSearch,
      getCustomMarkerIcon,
    }
  },
})
</script>

<style lang="scss" scoped>
.poi-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 80px 0 120px 0;
  position: relative;
}

.search-bar {
  position: relative;
  padding: 0 15px;
  margin-top: 20px;

  ion-input {
    --padding-start: 55px;
    --padding-top: 15px;
    --padding-bottom: 15px;
    border-radius: 28px;
    border: none;
    box-shadow: -7px 11px 29px -10px rgba(0, 0, 0, 0.2);
  }

  .search-button {
    position: absolute;
    left: 35px;
    top: 50%;
    bottom: 0;
    min-width: 23px;
    color: red;
    transform: translateY(-50%);
    z-index: 3;
  }
}

.poi__list {
  margin-top: 31px;
  padding: 0 15px;
  display: flex;
  flex-direction: column;

  &__item {
    display: flex;
    white-space: nowrap;
    align-items: center;

    margin-bottom: 16px;

    &:last-of-type {
      margin-bottom: 0;
    }

    &__marker {
      margin-left: 20px;
      min-width: 23px;
      margin-right: 13px;
    }

    &__name {
      margin: 0;
      overflow: hidden;
      font-size: 14px !important;
      font-weight: 900;
      text-overflow: ellipsis;
      letter-spacing: -0.3px;
      font-family: 'Poppins', sans-serif;
      max-width: calc(100vw - 32px - 30px - calc(23px + 20px + 13px) - calc(22px + 13px));
    }

    &__check {
      margin-left: auto;
      min-width: 22px;
    }
  }
}

.submit {
  --background: #e6224a;
  --box-shadow: none;
  max-width: 274px;
  margin: 0 auto;
  font-size: 16px;
  letter-spacing: -0.64px;
  margin-top: 90px;
  position: fixed;
  bottom: 100px;
  left: 50%;
  transform: translateX(-50%);
}
</style>
